"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplicationEDS = void 0;
const query_1 = require("@reduxjs/toolkit/query");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const useApplicationEDS = ({ applicationId, }) => {
    // API - GET
    const { data: lenderRequirements, isLoading: isLoadingLenderReqs } = (0, consumer_applications_v2_api_1.useGetConsumerApplicationsV2CreditApplicationsApplicationIdLenderRequirementsQuery)(applicationId ? { applicationId } : query_1.skipToken);
    // API - POST
    const [postVerifyEDS, { data: edsVerifyResp, isLoading: isLoadingEdsVerify },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsVerifyMutation)();
    const [postEventsEDS, { data: edsEventsResp, isLoading: isLoadingEdsEvents },] = (0, consumer_applications_v2_api_1.usePostConsumerApplicationsV2CreditApplicationsApplicationIdEdsEventsMutation)();
    return {
        lenderRequirements,
        edsVerifyResp,
        edsEventsResp,
        isLoadingLenderReqs,
        isLoadingEdsVerify,
        isLoadingEdsEvents,
        postVerifyEDS,
        postEventsEDS,
    };
};
exports.useApplicationEDS = useApplicationEDS;
